// This is a convenient wrapper function to intercept a form submission from PHP
export default function submitForm(document, form) {
    // debugger;

    return form.submit();
}

window.submitForm = submitForm;
